import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { useDebounce } from 'react-use'
import { galleryActions } from '../actions'
import { useNavigate, useLocation } from "react-router-dom"

const styles = {
    textField: {
        width: '15rem'
    },
    iconButton: {
        padding: 0,
    },
}

export default function SearchBox(props) {
    const { className, ...rest } = props

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [term, setTerm] = useState('')
    const [debouncedTerm, setDebouncedTerm] = useState()

    useDebounce(() => setDebouncedTerm(term),
        250,
        [term]
    )

    const submit = (e) => {
        e.preventDefault()
        if (location.pathname !== "/")
            navigate("/")
        dispatch(galleryActions.setCategoria(""))
        dispatch(galleryActions.setRubro(""))
        dispatch(galleryActions.setSubRubro(""))
        dispatch(galleryActions.setPromocion(""))
        dispatch(galleryActions.setSearchTerm(debouncedTerm))
    }

    return (
        <form onSubmit={(e) => submit(e)}>
            <TextField
                value={term}
                name="searchTerm"
                label="Buscar"
                size="small"
                fullWidth={false}
                style={`${styles.textField} ${className}`}
                onChange={(e) => setTerm(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            {term ?
                                <IconButton onClick={() => setTerm('')} style={styles.iconButton} size="large">
                                    <HighlightOffIcon fontSize="small" />
                                </IconButton> :
                                <SearchIcon />}
                        </InputAdornment>
                    ),
                }}
                {...rest}
            />
        </form>
    );
}